export default function NotFound() {
  return (
    <main className='min-h-screen bg-background'>
      <section className='py-16 md:py-24'>
        <div className='container mx-auto px-4 text-center'>
          <h1 className='text-3xl md:text-4xl font-semibold text-foreground mb-6'>
            Page not found
          </h1>
          <p className='text-muted-foreground'>Return to the home page.</p>
        </div>
      </section>
    </main>
  )
}


